import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { map, Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import { StationAP, StationAPResponse } from '../models/station.model';

/**
 * Analítica del dashboard (`catalogs-api/v1/stations/.../analytics/...`): disponibilidad y desempeño
 * general y por estación, uso por tipo de conector y uso por conector.
 */
@Injectable({
  providedIn: 'root',
})
export class StationsAPService {
  private baseUrl = `${environment.apiBaseUrl}/${environment.apiPrefixes.catalogs}/${environment.apiVersions.security}`;

  constructor(private http: HttpClient) {}

  getAvailabilityPerformance(
    page: number = 1,
    perPage: number = 10,
    filters: { [key: string]: any } = {},
  ): Observable<StationAPResponse> {
    let params = new HttpParams()
      .set('page', (page - 1).toString())
      .set('size', perPage.toString());

    Object.keys(filters).forEach((key) => {
      const value = filters[key];
      if (value !== null && value !== undefined && value !== '') {
        params = params.set(key, value.toString());
      }
    });

    return this.http
      .get<{
        data: StationAP;
        current_page: number;
        page_size: number;
        total_elements: number;
        total_pages: number;
      }>(`${this.baseUrl}/stations/analytics/availability-performance`, {
        params,
      })
      .pipe(
        map((response) => ({
          data: response.data,
          meta: {
            page: response.current_page + 1,
            per_page: response.page_size,
            total_pages: response.total_pages,
            total_items: response.total_elements,
          },
        })),
      );
  }

  getAvailabilityPerformanceById(id: number, params?: any): Observable<any> {
    return this.http
      .get<{
        data: any;
      }>(`${this.baseUrl}/stations/${id}/analytics/availability-performance`, {
        params,
      })
      .pipe(map((response) => response.data));
  }

  getConnectorTypeUsageById(id: number, params?: any): Observable<any> {
    return this.http
      .get<{
        data: any;
      }>(`${this.baseUrl}/stations/${id}/analytics/connector-type-usage`, {
        params,
      })
      .pipe(map((response) => response.data));
  }

  getConnectorUsageById(id: number, params?: any): Observable<any> {
    return this.http
      .get<{
        data: any;
      }>(`${this.baseUrl}/stations/${id}/analytics/connector-usage`, { params })
      .pipe(map((response) => response.data));
  }
}
